<template>
    <div class="footCon">
    <div class="first">
  <div class="one">
   <p class="title" @click="goto(1)">{{$t('home[4]')}}</p>
    <div class="item itemThree">
      <p @click="goto(2)">{{$t('home[1]')}}</p>
      <p @click="gotoAbout(0)">{{$t('aboutList[0]')}}</p>
      <p @click="gotoAbout(1)">{{$t('aboutList[1]')}}</p>
      <p @click="gotoAbout(2)">{{$t('aboutList[2]')}}</p>
    </div>
    <div class="item itemT itemThree" style="text-transform: capitalize">
      <p @click="goto(3)">{{$t('home[0]')}}</p>
<!--      <p>Window lift motor</p>-->
<!--      <p>wiper motor</p>-->
<!--      <p>headlight motor</p>-->
<!--      <p>transfer case Motor</p>-->
<!--      <p>accessories</p>-->
      <p @click="gotoPro(index,item.ID)" v-for="(item,index) in proList" :key="index">{{item.CALLED}}</p>
    </div>
    <div class="item">
      <p @click="goto(4)">{{$t('home[2]')}}</p>
      <p @click="gotoTe(0)">{{$t('teList[0]')}}</p>
      <p @click="gotoTe(1)">{{$t('teList[1]')}}</p>
      <p @click="gotoTe(2)">{{$t('teList[2]')}}</p>
    </div>
    <div class="item itemT" style="text-transform: capitalize">
      <p @click="goto(5)">{{$t('home[3]')}}</p>
      <p @click="gotoMark(0)">{{$t('mkList[0]')}}</p>
      <p @click="gotoMark(1)">{{$t('mkList[1]')}}</p>
      <p @click="gotoMark(2)">{{$t('mkList[2]')}}</p>
    </div>
  </div>
      <div class="main">
        <p class="title" @click="goto(6)">{{$t('footCon[0]')}}</p>
        <div class="lx">
          <p>{{$t('footCon[4]')}}</p>
          <a href="tel:86-574-83552189"><p>{{$t('footCon[1]')}}</p></a>
          <p>{{$t('footCon[2]')}}</p>
          <p>{{$t('footCon[3]')}}</p>
         <a href="mailto:name@email.com"><p>{{$t('footCon[5]')}}</p></a>
          <p>{{$t('footCon[6]')}}</p>
          <p>{{$t('footCon[7]')}}</p>
        </div>
        <div class="five">
          <img class="bigImg" src="../assets/b.png" alt="">
          <div class="smallImg">
            <a href="https://www.facebook.com/profile.php?id=100010733700599"><i class="iconfont icon-facebook b" style="margin-top: 15px;"></i></a>
            <a href="https://www.linkedin.com/company/ningbo-binyu-motor-co-ltd/?viewAsMember=true"><i class="iconfont icon-in b"></i></a>
            <a href="https://www.youtube.com/channel/UC26ebKyzDqew_tuo_dTOIiQ"><i class="iconfont icon-youtube b " ></i></a>
<!--            <i class="iconfont icon-google b" style="margin-top: 15px;"></i>-->
            <a href="https://twitter.com/abigalelizi" ><i class="iconfont icon-tuite b bTwo" style="line-height: 22px;"></i></a>
          </div>
        </div>
      </div>
      <div class="right">
       <p>{{$t('home[5]')}}</p>
        <div class="info">
          <input v-model="form.name" type="text" :placeholder="$t('feedBack[0]')">
          <input v-model="form.email" type="text" :placeholder="$t('feedBack[1]')">
          <span>{{$t('feedBack[2]')}}</span>
          <input v-model="form.msg" class="lastIn" type="text">
        </div>
        <img src="../assets/binyu.jpg" alt="" style="height:150px;width:150px;margin-top: 20px;" v-show="$i18n.locale==='zh-CN'">
        <span class="btn" @click="send">{{$t('send')}}</span>
      </div>
      <div class="lastTwo">
      <span>
        <i class="iconfont icon-xiangshang"  @click="menuclose"></i>
      </span>
        <span>
      <i class="iconfont icon-xiaoxi"></i>
        </span>
      </div>
    </div>
      <div class="second">
     <span>{{$t('footInfo[0]')}}</span>
        <span><a target="_blank" href="https://www.sansg.com/">{{$t('footInfo[1]')}}</a></span>
      </div>
    </div>
</template>

<script>
  import {getProductstypeUrl2} from '../util/lang'
  import qs from 'qs'
    export default {
        name: "foot",
      data(){
          return{
            proList:[],
            form:{
              name:'',
              email:'',
              msg:'',
            }
          }
      },
      mounted(){
        this.getPro()
      },
      methods:{
        menuclose(){
          this.$emit('gotoTop')
        },
        getPro(){
          this.$nextTick(()=>{
            const url = `${getProductstypeUrl2( this.$i18n.locale)}`
            this.$axios.get(url).then(res => {
              this.proList=res.data.slice(1,6)
            })
          })
        },
        goto(index){
          if(index===1){
            this.$router.push({path:'/home'})
          }
          else if(index===2){
            this.$router.push({path:'/about'})
          }else if(index===3){
            this.$router.push({path:'/product'})
          }else if(index===4){
            this.$router.push({path  :'/tech'})
          }else if(index===5){
            this.$router.push({path:'/market'})
          }else {
            this.$router.push({path:'/support'})
          }
        },
        gotoAbout(index){
          this.$router.push({path:'/about',query:{select:index}})
        },
        gotoPro(index,id){
          this.$router.push({path:'/product',query:{select:index,id:id}})
        },
        gotoTe(index){
          this.$router.push({path:'/tech',query:{select:index}})
        },
        gotoMark(index){
          this.$router.push({path:'/market',query:{select:index}})
        },
          send(){
            let form=this.form
            let reg=/^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/;
            if(form.name==''|| form.msg==''){
              this.$notify({
                title: 'Prompt',
                message: 'Please complete',
                offset: 100
              });
            }else if(!reg.test(form.email)){
              this.$notify({
                title: 'Prompt',
                message: 'The mailbox format is incorrect.',
                offset: 100
              });
            }else{
              this.$nextTick(()=>{
                const url ='/php/form.php'
                this.$axios.post(url,
                  qs.stringify(
                   this.form
                  )
                ).then(res => {
                  if(res.status==200)
                  {
                    this.$notify({
                      title: 'Success',
                      message: 'Submitted successfully',
                      offset: 100
                    })
                    this.form={
                      name:'',
                      email:'',
                      msg:''
                  }
                  }else{
                    this.$notify({
                      title: 'Fail',
                      message: 'Submission Failed',
                      offset: 100
                    });
                  }
                })
              })
            }
          }
      }
    }
</script>

<style lang="scss" scoped>
.footCon{
  width:80%;
  margin-left:10%;
  padding-top: 30px;
  .first{
    width:100%;
    display: flex;
    flex-direction: row;
    padding-bottom: 30px;
    border-bottom: 1px solid #E5E5E5;
    padding-left: 5%;
    .one{
      width:40%;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      .title{
        font-size: 25px;
        font-weight: bold;
        text-align: left;
        color:#0C3665;
        width:100%;
      }
      .item{
        width:40%;
        margin-top: 40px;
        font-family: light;
        p{
          line-height: 28px;
          font-size: 14px;
          color:#60656A;
          cursor: pointer;
          transition:color 2s;
          -webkit-transition:color 2s ;
        }
        p:first-child{
          font-size: 16px;
          font-weight: bold;
          color:#0C3665;
        }
        p:hover{
          color:#C7000C;
        }
      }
      .itemT{
        margin-left:20%;
      }
      .itemThree{
        margin-top: 0;
      }
    }
    .main{
      width:20%;
      text-align: left;
      margin-left: 5%;
      .title{
        font-size: 25px;
        font-weight: bold;
      }
      .lx{
        text-align: left;
        width:100%;
         margin-top: 80px;
        font-size: 14px;
        transition:color 2s;
        -webkit-transition:color 2s ;
        font-family: light;
        a{
          p{
            color:#60656A;
          }
          p:hover{
            color:#C7000C;
            cursor: pointer;
          }
        }
        p{
          transition: all 2s;
        }
        p:hover{
          color:#C7000C;
          cursor: pointer;
        }
      }
      .five{
        display: flex;
        flex-direction: column;
        margin-top: 60px;
      width:100%;
        .bigImg{
          margin: 0 auto;
        }
        .smallImg{
          display: flex;
          flex-direction: row;
          margin-top: 15px;
          width:80%;
          margin-left: 10%;
          justify-content: space-between;
          a{
            padding-top: 5px;
          }
          .b{
            margin-left: 10%;
            transition:color 2s;
            -webkit-transition:color 2s ;
            color:#9F9F9F;
          }
          .b:hover{
            color:#C7000C;
          }
        }
      }
    }
    .right{
      width:25%;
      margin-left: 5%;
      position: relative;
      p{
        text-align: left;
        font-size: 25px;
        font-weight: bold;
      }
      .info{
        width:100%;
        display: flex;
        flex-direction: column;
        margin-top: 50px;
        input{
          border-bottom: 1px solid #E0E0E0;
          border-top: none;
          border-left: none;
          border-right: none;
          height:40px;
          color:#C7000C;
          margin-top: 20px;
          font-family: light;
        }
        input:focus{
          outline: none;
        }
        span{
          color:#60656A;
          font-size: 14px;
          margin-top: 30px;
          font-family: light;
        }
        .lastIn{
          margin-top: 60px;
        }
      }
      .btn{
        font-weight: bold;
        position: absolute;
        right:0;
        margin-top: 30px;
        display: inline-block;
        color:#C7000C;
        padding: 6px 10%;
        font-size: 10px;
        border: 1px solid #0C3665;
        -webkit-border-radius: 60px / 60px;
        -moz-border-radius: 60px / 60px;
        border-radius: 60px / 60px;
        cursor: pointer;
        background: linear-gradient(top, #0C3665,#0C3665) no-repeat;
        background-size: 100% 0%;
        text-transform: uppercase;
        -webkit-transition: all .5s;
        transition: all .5s;
      }
      .btn:hover{
        background-size: 100% 100%;
        color: white;
      }
    }
    .lastTwo{
      width:5%;
      display: flex;
      flex-direction: column-reverse;
      span{
        width:49px;
        height:49px;
        border-radius: 50%;
        margin-left: 20%;
        margin-bottom: 10px;
        cursor: pointer;
        position: relative;
        background: linear-gradient(top,#0D80CA,#0D80CA) no-repeat;
        background-size: 100% 0%;
        text-transform: uppercase;
        -webkit-transition: all .5s;
        transition: all .5s;
        background-color: #cbcbcb;
        text-align: center;
        line-height: 50px;
        color:white;
      }
      span:hover{
        background-size: 100% 100%;
      }
    }
  }
  .second{
    width:100%;
    position: relative;
    padding-top: 30px;
    padding-bottom: 30px;
    font-family: light;
    span{
      font-size: 15px;
      color:#626262;
      transition:color 2s;
      -webkit-transition:color 2s ;
    }
    span:hover{
      color:#C7000C;
    }
   span:last-child{
     position: absolute;
     cursor: pointer;
     right:0;
    a{
      color:#626262;
      transition:color 2s;
      -webkit-transition:color 2s ;
    }
     a:hover{
       color:#C7000C;
     }
   }
  }
  @media screen and (max-width: 1366px){
    .first{
      .lastTwo{
        span{
          width:40px;
          height:40px;
          line-height: 40px;
          font-size: 30px !important;
        }
      }
    }
  }
  @media screen and (max-width:768px){
      width:100%;
      margin-left: 0;
    .second{
      width:90%;
      margin-left: 5%;
    }
    .first{
      .main{
        .five{
          .bgImg{
            width:200px;
          }
        }
      }
    }
  }
  @media screen and (max-width:450px){
  .first{
    flex-direction: column;
    .one{      /*width:90%;*/
      /*margin-left: 5%;*/
      /*.title{*/
      /*  font-size: 18px;*/
      /*}*/
      /*.item{*/
      /*  p:first-child{*/
      /*    font-size: 14px;*/
      /*  }*/
      /*}
*/
      display: none;
    }
     .main{
       width:90%;
       margin-left: 5%;
       .lx{
         margin-top: 0;
       }
       .five{
         text-align: left;
         margin-top: 0;
         .bigImg{
           display: none;
         }
         .smallImg{
           margin-left: 0;
         }
       }
    .title{
      font-size: 18px;
    }
  }
    .right{
      width:80%;
      margin-left: 5%;
      .info{
        margin-top: 0;
        input{
          margin-top: 0;
        }
        .lastIn{
          margin-top: 0;
        }
      }
      p{
        font-size: 18px;
      }
    }
    .lastTwo{
      width:50%;
      margin-top: 20px;
    }
  }
    .second{
      display: flex;
      flex-direction: column;
      span{
        font-size: 12px;
      }
      span:last-child{
        position: static;
        margin-top: 20px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/foot.vue